module.exports = __webpack_public_path__ + "static/img/partnersBanner_m.9a9a2d4a.png";